import { breakpoints } from '@gassan-ui'
import styled, { css } from 'styled-components'

export const Slider = styled.section`
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
  scrollbar-color: rgba(0, 0, 0, 0);
  scrollbar-width: none;
  position: relative;
  width: 100%;

  /** Disallow swiping on non-touch devices */
  @media (hover: hover) and (pointer: fine) {
    overflow-x: hidden;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  &::before {
    padding-top: 90%;
    content: '';
    display: block;
  }
`

export const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  scroll-snap-align: start;
  min-width: 100%;
  position: relative;

  img {
    /* object-position: center center !important; */
  }
`

export const NavButton = styled.button<{ direction: 'left' | 'right' }>`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  margin-top: -21px;
  z-index: 2;
  color: white;
  outline: 0;
  display: none;
  @media screen and (min-width: ${breakpoints.large}) {
    display: block;
  }
  ${p =>
    p.direction === 'left'
      ? css`
          left: -25px;
        `
      : css`
          right: -25px;
        `}
`
